import ObservationCardGridView from "@/components/observations/ObservationCardGridView";
import { useAreaName } from "@/hooks/useAreaName";
import type { LayoutContext } from "@/lib/models";
import { Observation, ObservationService } from "@/services/ObservationService";
import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";

const AreaHabitatObservationListPage: React.FC = () => {
  const [observations, setActionsList] = useState<Observation[]>([]);
  const params = useParams();
  const { areaName } = useAreaName(params.areaId!);
  const { setPageName } = useOutletContext<LayoutContext>();

    useEffect(() => {
      setPageName(`Feature: ${areaName} Habitat Observations`);
    }, [areaName, setPageName]);

  useEffect(() => {
    ObservationService
      .getByAreaIdHabitat(params.areaId!)
      .then(setActionsList);
  }, [params.siteId]);

  return (
    <div className="container mx-auto p-4">
      <ObservationCardGridView observations={observations} pageTitle={`Area: ${areaName} Habitat Observations`} />
    </div>
  );
};

export default AreaHabitatObservationListPage;
